const url = process.env.NODE_ENV === 'production' ? 'https://td-backend.shujaatazim.com' : 'http://localhost:3000'

export default url